import { get } from 'axios';

export const getTermsConditions = async bookingRef => {
  const { data } = await get(`/api/package/${bookingRef}/termsandconditions`);
  return data;
};
